import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';

// services
import { AssetStatsRatesService } from './asset-stats-rates.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class AssetStatsRatesServiceModule {
  static forRoot(): ModuleWithProviders<AssetStatsRatesServiceModule> {
    return {
      ngModule: AssetStatsRatesServiceModule,
      providers: [AssetStatsRatesService],
    };
  }
}
